/* ==========================================================================
   ProductCardLeiRxjs > Client
   ========================================================================== */

/* Import modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');

const prototype = require('./prototype');
const config = require('./config');

/**
 * ProductCardLeiRxjs component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function ProductCardLeiRxjs(selector = '[data-component="ProductCardLeiRxjs"]', configuration = {}) {
    if (elementExist(selector)) {
        /* Instance */
        const instance = Object.create(prototype);

        /* Selector */
        instance.selector = selector;

        /* Element */
        instance.element = document.querySelector(selector);

        /* Config */
        instance.config = {
            ...config(),
            ...configuration,
            ...(function getConfig() {
                if (!instance.element.dataset.config) return '';

                const result = JSON.parse(instance.element.dataset.config);
                instance.element.dataset.config = '';

                return result;
            })()
        };

        /* Hooks */
        instance.hooks = {
            images: [
                instance.element.querySelector(`[data-component="ImageRxjs"][data-type="${config().type.image}"]`),
                instance.element.querySelector(
                    `[data-component="ImageRxjs"][data-type="${config().type.secondaryImage}"]`
                )
            ],
            tabs: [...instance.element.querySelectorAll('[data-product-card-tab]')]
        };

        /* Init */
        instance.init();

        return instance;
    }
};
